import { Observable } from 'rxjs';
import { UsernamePrefix } from '../../models/usernamePrefix';
import { TrialRegistration } from '../../models/trialRegistration';
import { TrialOrgInfo } from '../../models/trialOrgInfo';

export abstract class ITrialService {
  public abstract getPrefixSuggestion(orgName: string): Observable<UsernamePrefix>;
  public abstract isPrefixAvailable(prefix: string): Observable<UsernamePrefix>;
  public abstract registerTrial(trialInfo: TrialRegistration): Observable<any>;
  public abstract startTrial(orgPrefix: string): Observable<any>;
  public abstract startTrialWithPaymentMethod(orgPrefix: string, paymentMethodId: string, selectedPlan: string): Observable<any>;
  public abstract startExistingTrial(orgPrefix: string): Observable<any>;
  public abstract enablePinnacle(orgPrefix: string, userId: string): Observable<TrialOrgInfo>;
  public abstract submitHubspotPartialForm(trialInfo: TrialRegistration): Observable<any>;
  public abstract submitHubspotCombinedForm(trialInfo: TrialRegistration): Observable<any>;
  public abstract submitHubspotPinnacleForm(trialInfo: TrialOrgInfo): Observable<any>;
  public abstract getStripePublicKey(): Observable<string>;
}
